import React from 'react';
import { DynamicForm } from '@/components/forms/dynamic-form/DynamicForm';
import { FieldValues, UseFormSetError } from 'react-hook-form';
import styles from './RegisterForm.module.scss';
import { createSchema, IAPIFormSchema } from '@/services/formSchema.service';
import { useTranslation } from '@app/i18n/useTranslationClient';
import { FormHeader } from '@/components/forms/form-header/FormHeader';
import { useRegistration } from '@/hooks/api/useRegisterion/useRegistration';
import { IRegistrationRequest } from '@/hooks/api/useRegisterion/useRegistration.interfaces';
import { handleFormServerErrors } from '@/components/dynamic-field/field-input/fieldInput.helper';
import { useRouter } from 'next/navigation';
import { translate } from '@/translations/static/staticTranslations';
import { AdditionalInfoElement } from '@/components/dynamic-field/field-additional-info/AdditionalInfoElement';
import { IRegistrationFormSchemaResponse } from '@/hooks/api/fetchRegistrationFormSchema/useRegistrationFormSchema.interfaces';

interface IRegisterForm {
    schema: IRegistrationFormSchemaResponse;
    shouldDisplayHeader: boolean;
}

export const RegisterForm = (props: IRegisterForm) => {
    const { t } = useTranslation();
    const router = useRouter();
    const { register, loading } = useRegistration();
    const {
        i18n: { language },
    } = useTranslation();
    const registerAdditionalInfo = AdditionalInfoElement(props.schema.registerAdministratorInfo);

    const registrationSchema = createSchema(props.schema as unknown as IAPIFormSchema, language, t);

    const onFormSubmit = async (data: FieldValues, setErrors: UseFormSetError<any>) => {
        const response = await register(data as IRegistrationRequest);

        if (response.success) {
            router.push(translate(language, 'routes.account'));
        }
        if (response.errors) {
            handleFormServerErrors(setErrors, response.errors);
        }
    };

    return (
        <div data-testid={'registerForm'}>
            {props.shouldDisplayHeader && <FormHeader label={t('translations.register.form.title')} />}
            <div className={styles.form}>
                <DynamicForm
                    formSchema={registrationSchema}
                    element={registerAdditionalInfo}
                    formSubmitButtonLabel={t('translations.register.form.registerButton')}
                    onFormSubmit={onFormSubmit}
                    isSubmitButtonDisabled={loading}
                />
            </div>
        </div>
    );
};
